var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"PanelFooter"},[_c('p',[_vm._v("Copyright © Telestrada S.A. "+_vm._s(new Date().getFullYear()))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b5b94a","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelFooter/index.vue
// module id = 1329
// module chunks = 2